import { Tooltip } from 'antd';
import {InfoCircleOutlined }from "@ant-design/icons";

const TooltipinfoHomepage = () => (
  <Tooltip title="Create New model By Uploading New File.">
    <span><InfoCircleOutlined /></span>
  </Tooltip>
);

export default TooltipinfoHomepage;